import Task from './Task';
import { createError } from '../error';

const removeSecondaryClaim = '/staffing_user/{{staffing_users_id}}/events/{{events_id}}/secondary_claims/{{claims_id}}/remove';

class RemoveSecondaryClaimTask extends Task {
  constructor($q, APIService, ClaimService, LogService) {
    super();
    this.$q = $q;
    this.APIService = APIService;
    this.ClaimService = ClaimService;
    this.LogService = LogService;
  }

  /**
   * Public properties
   */

  get canExecute() {
    return this.APIService.isOnline;
  }

  set serializedClaim(claim) {
    this._serializedClaim = claim;
  }

  get serializedClaim() {
    return this._serializedClaim;
  }

  /**
   * Public methods
   */

  setClaim(claim) {
    this.serializedClaim = this.ClaimService.serialize(claim);
  }

  populate(data) {
    this.serializedClaim = data.serializedClaim;
  }

  serialize() {
    return {
      serializedClaim: this.serializedClaim,
    };
  }

  execute() {
    const serializedClaim = this.serializedClaim;
    const url = removeSecondaryClaim
      .replace('{{staffing_users_id}}', serializedClaim.staffing_users_id)
      .replace('{{events_id}}', serializedClaim.events_id)
      .replace('{{claims_id}}', serializedClaim.id);
    return this.APIService.post(url)
      .catch(response => {
        this.LogService.error("Error removing claim; response:", response);
        return this.$q.reject(createError({
          error: 'ErrorRemovingClaim',
          message: 'There was an error removing the claim',
          response,
        }));
      });
  }
}

export default RemoveSecondaryClaimTask;
